import { BasemapProvider } from "../providerTypes";
export const noBasemapProvider: BasemapProvider={id:"none",label:"None (neutral background)",external:false,defaults:{provider:"none",enabled:false}};
